import React from 'react';
import {makeStyles} from "@material-ui/core/styles/index";
import Grid from "@material-ui/core/es/Grid/Grid";
import {Item} from "./Item";

const useStyles = makeStyles((theme) => {
    return {
        root: {
            marginTop: 50,
            paddingBottom: 40,
            borderBottom: '1px solid #eee',
            ['@media (max-width:500px)']: {
                marginTop: 20,
                paddingBottom: 20,
                borderBottom: 'none',
                marginRight: 15
            }
        },
        h2: {
            fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
            fontWeight: 400,
            fontSize: '1.5rem',

            width: 447,
            marginLeft: 'auto',
            marginRight: 'auto',
            ['@media (max-width:500px)']: {
                marginLeft: 15,
                width: 'auto',
            }
        },
        grid: {
            maxWidth: 1000,
            marginLeft: 'auto',
            marginRight: 'auto',
            marginTop: 20,
        },
        grid2: {
            maxWidth: 1000,
            marginLeft: 'auto',
            marginRight: 'auto',
            ['@media (max-width:500px)']: {
                marginTop: 4,
            }
        }
    }}
);

export default function BrowseBodyType(props) {
    const classes = useStyles();

    const maxWidth = Math.min(1000, props.screenWidth);
    console.log('maxWidth', maxWidth)

    const cells = maxWidth < 700 ? 2 : 4;

    const size = 12/cells;

    console.log('maxWidth', maxWidth);

    let padding = maxWidth <= 900 ? 0 : 20;
    if (maxWidth < 700) {
        padding = 4;
    }
    if (maxWidth <= 500) {
        padding = 8;
    }
    const cellW = (maxWidth / cells) - padding;

    const cellH = Math.round(cellW / 1.333333);

    return (
        <div className={classes.root}>
            <h2 className={classes.h2}>Browse by style</h2>
            <Grid container spacing={1} className={classes.grid}>
                <Grid item md={size} sm={size} xs={size}>
                    <Item item={{image: '/i/assets/style/SUV.jpg', url: '/used-cars/options/SUV'}}
                          cellW={cellW} cellH={cellH} type="SUV"/>
                </Grid>
                <Grid item md={size} sm={size} xs={size}>
                    <Item item={{image: '/i/assets/style/truck.jpg', url: '/used-cars/options/truck'}}
                          cellW={cellW} cellH={cellH} type="Truck"/>

                </Grid>
                <Grid item md={size} sm={size} xs={size}>
                    <Item item={{image: '/i/assets/style/sedan.jpg', url: '/used-cars/options/sedan'}}
                          cellW={cellW} cellH={cellH} type="Sedan"/>
                </Grid>
                <Grid item md={size} sm={size} xs={size}>
                    <Item item={{image: '/i/assets/style/coupe.jpg', url: '/used-cars/options/coupe'}}
                          cellW={cellW} cellH={cellH} type="Coupe"/>
                </Grid>
            </Grid>
            <Grid container spacing={1} className={classes.grid2}>
                <Grid item md={size} sm={size} xs={size}>
                    <Item item={{image: '/i/assets/style/convertible.jpg', url: '/used-cars/options/convertible'}}
                          cellW={cellW} cellH={cellH} type="Convertible"/>
                </Grid>
                <Grid item md={size} sm={size} xs={size}>
                    <Item item={{image: '/i/assets/style/wagon.jpg', url: '/used-cars/options/wagon'}}
                          cellW={cellW} cellH={cellH} type="Wagon"/>

                </Grid>
                <Grid item md={size} sm={size} xs={size}>
                    <Item item={{image: '/i/assets/style/minivan.jpg', url: '/used-cars/options/minivan'}}
                          cellW={cellW} cellH={cellH} type="Minivan"/>
                </Grid>
                <Grid item md={size} sm={size} xs={size}>
                    <Item item={{image: '/i/assets/style/hatchback.jpg', url: '/used-cars/options/hatchback'}}
                          cellW={cellW} cellH={cellH} type="Hatchback"/>
                </Grid>
            </Grid>

        </div>
    );
}
